import { NgModule } from '@angular/core';
import { RappiderMonacoEditorModule } from './monaco-editor.module';
import { MONACO_EDITOR_DEFAULT_CONFIG } from './deafult-monaco-editor-options';

@NgModule({
  imports: [
    RappiderMonacoEditorModule.forRoot(MONACO_EDITOR_DEFAULT_CONFIG)
  ],
  providers: [],
  exports: [RappiderMonacoEditorModule]
})
export class RappiderMonacoEditorRootModule { }
